<template>
	<v-card 
		class="text-center mx-auto"
		:max-width="maxWidth"
		:width="width"
		flat
	>
		<v-card-item>
			<v-card-title :class="titleClass">
				{{ title }}
			</v-card-title>
			<v-card-subtitle :class="subtitleClass">
				{{ subtitle }}
			</v-card-subtitle>
		</v-card-item>

		<v-card-text>
			{{ text }}
		</v-card-text>
		<v-card-text class="text-left mx-auto">

			<v-list lines="three">
				<v-list-item
					v-for="item in items"
					:key="item.title"
					:subtitle="item.subtitle"
					:title="item.title"
					@click="onOpen(item)"
				>
					<template v-slot:prepend>
						<v-avatar>
							<v-icon :icon="item.icon" :color="item.color" size="x-large"></v-icon>
						</v-avatar>
					</template>

					<template v-slot:append>
						<v-btn
							icon="mdi-download"
							variant="text"
							@click.stop="onDowdload(item)"
						></v-btn>
					</template>
				</v-list-item>
			</v-list>
			<v-btn class="my-6 me-2 text-none font-weight-bold" block @click="onDiiaSign">Дія.Підпис</v-btn>
		</v-card-text>
	</v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import mixin from './mixin/main'

export default {
	mixins: [mixin],
	computed: {
		//...mapGetters([ 'ClaimNumber' ]),

		documents() {
			//console.log(this.$options.name, 'onOpen', 'claim', this.claim)

			//return this.claim?.signdocuments ? this.claim.signdocuments : []
			return this.claim?.documents ? this.claim.documents : []
		},

		items() {
			let result = []

			this.documents.forEach((document) => {
				document.files.forEach((file) => {
					result.push({
						name: document.type.name,
						code: document.type.code,
						title: document.type.name,
						subtitle: `${file.name}.${file?.extension}`,
						filename: `${file.name}.${file?.extension}`,
						//path: `/${document.type.code}/${file.name}.${file?.extension}`,
						icon: file?.extension=='pdf' ? 'mdi-file-pdf-box' : 'mdi-file',
						color: file?.extension=='pdf' ? 'red darken-4' : null
					})
				})
			})

			//console.log(this.$options.name, 'items', 'result', result)

			return result
		}
	},

	methods: {
		onOpen(item) {
			//console.log(this.$options.name, 'onOpen', 'item', item)

			var that = this
			axios.get(`/claim/${this.claim.number}/document/${item.code}/file/${item.filename}`, {
				responseType: 'blob' 
			}).then(response => {
				const blob = new Blob([response.data], { type: 'application/pdf' })
				const blobUrl = URL.createObjectURL(blob);
    			window.open(blobUrl, '_blank');

			}).catch(console.error)

		},

		onDowdload(item) {
			//console.log(this.$options.name, 'onDowdload')
			
			var that = this
			axios.get(`/claim/${this.claim.number}/document/${item.code}/file/${item.filename}`, {
				responseType: 'blob' 
			}).then(response => {
				const blob = new Blob([response.data], { type: 'application/pdf' })
				const link = document.createElement('a')
				link.href = URL.createObjectURL(blob)
				link.download = item.filename
				link.click()
				URL.revokeObjectURL(link.href)
			}).catch(console.error)
		},
		
		onDiiaSign() {

		},
	},
}
</script>
